import React from 'react';
import {OrderType} from "../../../../../../../services/Api/types";
import OrderTypeIcon from "../../../../../../../components/Common/OrderTypeIcon";
import {useTranslation} from "react-i18next";
import {ReactComponent as RemoveIco} from "../../../../../../../../images/icons/remove.svg";

interface Props {
    orderType: OrderType;
    selected: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    session: Record<string, any>;
    placeInfo: {
        placesNumber: number;
        nearestPlaceDistance: number | undefined;
        outsideDeliveryZone: boolean;
    };
}

const OrderTypesFilterButton = ({orderType, selected, onClick, session, placeInfo}: Props) => {
    const {t} = useTranslation();

    const getInfoBadge = () => {
        if (!placeInfo.placesNumber && placeInfo.outsideDeliveryZone) {
            return t("modules.multistore.field.outside_delivery_zone.title");
        }

        if (placeInfo.nearestPlaceDistance !== undefined) {
            return `${t("modules.multistore.field.the_nearest.title")}: ${placeInfo.nearestPlaceDistance} km`;
        }

        return "";
    }

    return (
        <div className="order-type-filter-btn-wrapper">
            <button className={`btn btn-default ${selected ? "selected" : ""}`} onClick={onClick}>
                <OrderTypeIcon orderType={orderType}/>
                <span>{t(`enums.order.type.${orderType}`)}</span>
                <div className="d-flex align-items-center gap-1">
                    <div className="quantity-badge">
                        {placeInfo.placesNumber}
                    </div>
                    {selected && <RemoveIco/>}
                </div>
            </button>
            {session.full_address && getInfoBadge() && <div
                className={`info-badge ${!placeInfo.placesNumber && placeInfo.outsideDeliveryZone ? "text-danger" : ""}`}>
                {getInfoBadge()}
            </div>}
        </div>
    )
}

export default OrderTypesFilterButton;